import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Temario } from './components/Temario';
import { Bonuses } from './components/Bonuses';
import { Carousel } from './components/Carousel';
import { Comparison } from './components/Comparison';
import { Purchase } from './components/Purchase';
import { Testimonials } from './components/Testimonials';
import { Objections } from './components/Objections';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('comprar');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero onCTAClick={scrollToPurchase} data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Temario data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Carousel onImageClick={scrollToPurchase} data-id="element-6" />
      <Comparison data-id="element-7" />
      <Purchase data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Objections onCTAClick={scrollToPurchase} data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchasePopup data-id="element-12" />
    </div>;
}